import { Footer } from 'components/Footer'
import { Header, HeaderType } from 'components/Header'
import { useCategoryQuery } from 'hooks/useCategoryQuery'
import { usePropertyQuery } from 'hooks/usePropertyQuery'
import { useZoneQuery } from 'hooks/useZoneQuery'
import { NextPage } from 'next'
import Error from 'next/error'
import { useRouter } from 'next/router'
import { findRole } from 'utils/role'
import { Property } from 'views/property'
import { setCookie, parseCookies } from 'nookies'
import { useEffect, useState } from 'react'
import { useMutation } from '@apollo/react-hooks'
import { CREATE_RECORD } from 'apollo'

const agentCookieName = 'AGENT_COOKIE'

const onclickShare = (agent: any) => {
  // if (getAgentCookie()) {
  //   return
  // }
  // setAgentCookie(agent)
}
const setAgentCookie = (agent: any) => {
  setCookie(null, agentCookieName, JSON.stringify(agent), {
    maxAge: 7 * 24 * 60 * 60,
    path: '/',
    httpOnly: false
  })
}

const getAgentCookie = () => {
  const cookies = parseCookies()
  return cookies[agentCookieName] ? JSON.parse(cookies[agentCookieName]) : null
}

interface Props {
  agentCookie?: any
}
const PropertyPage: NextPage<Props> = ({ agentCookie }) => {
  const { query } = useRouter()
  const [cleanUrl, setCleanUrl] = useState('')
  const [visitRecoded, setVisitRecoded] = useState(false)
  const [create, { data, error }] = useMutation(CREATE_RECORD, { variables: {} })
  if (!visitRecoded) {
    setVisitRecoded(true)
    if (query && query.propertyUuid && query.c) {
      const c = query.c as string
      const source = c.substring(c.length - 2)
      const code = c.substring(0, c.length - 2)
      create({
        variables: {
          u: query.propertyUuid,
          s: source,
          c: code,
        }
      })
    }
  }
  useEffect(() => {
    setCleanUrl(window.location.href)
  }, [])
  const role = findRole(query.roleSlug)

  const categoryQuery = useCategoryQuery({ variables: { query: query.categorySlug } })
  const category = categoryQuery.data?.category

  const zoneQuery = useZoneQuery({ variables: { query: query.zoneSlug } })
  const zone = zoneQuery.data?.zone

  const propertyQuery = usePropertyQuery({ variables: { uuid: query.propertyUuid } })
  const property = propertyQuery.data?.property

  if (categoryQuery.loading || zoneQuery.loading || propertyQuery.loading) {
    return null
  }

  if (!role || !category || !zone || !property) {
    return <Error statusCode={404} />
  }

  const agent = property.owner
  const shareUrl = cleanUrl.split('?')[0]
  return (
    <>
      <Header type={HeaderType.Property} {...{ role, category, zone, property }} />
      <Property {...{ role, category, zone, property, shareUrl }} agent={agent} beforeOnShareClick={async () => { onclickShare(agent) }} />
      <Footer />
    </>
  )
}

PropertyPage.getInitialProps = async (ctx) => {
  const cookies = parseCookies(ctx)
  return { agentCookie: cookies[agentCookieName] ? JSON.parse(cookies[agentCookieName]) : null }
}

export default PropertyPage
